import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch,useSelector } from "react-redux";
import { getItemInfoOfcView ,itemtatusChange} from "../../../store/actions/ItemAction";
import { Loader, htmlDecode } from '../../../utils/tools';
import { getUserData } from '../../../utils/tools';
import ItemStatusChange from "../../../utils/itemStatusChange";
import Divider from '@mui/material/Divider' ;
import ItemcostInfo from "../../../utils/itemcostInfo";
import Button from '@mui/material/Button';
import DateDisplay from "../../../utils/form/dateDisplay";

const ItemInfoOfcView =()=>{
   
    const iteminfo= useSelector(state=>state.itemsReducer);
    const dispatch = useDispatch();
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(()=>{
        dispatch(getItemInfoOfcView(id))
        .unwrap()
        .then(()=>{
         //navigate(`/`)
   
          
        })
     },[id,dispatch])



     const goToNewsAproval = (id,itemid,type) => {
         

        if(type==="item"){
            
          
            //dispatch(getPaginateArticles({page}))
            const data = {
                onlineId:id,
                finalApproved:getUserData().userId,
                itemID:itemid
               
               
                
          };
          const addURL="api/onlitms/aprve";
            
        
      dispatch(itemtatusChange({data,addURL}))
                  .unwrap()
                  .then(()=>{
                   //navigate(`/dashboard/articlesOfc/article/${id}`)
                   window.location.reload();
                    
                  })
            
              }
              
        
    }

    const goToNewsPublish = (id,itemid,type) => {
        

        if(type==="item"){
            
          
            //dispatch(getPaginateArticles({page}))
            const data = {
                onlineId:id,
                finalApproved:getUserData().userId,
                itemID:itemid
               
                
          };
   

          const addURL="api/onlitms/pblsh";
            
        
      dispatch(itemtatusChange({data,addURL}))
                  .unwrap()
                  .then(()=>{
                   navigate(`/dashboard/articlesOfc/article/${id}`)
                  // window.location.reload();
                    
                  })
            
              }
              
    }  

    const goToNewsBlock = (id,itemid,type) => {
          

       
        if(type==="item"){
            
          
            //dispatch(getPaginateArticles({page}))
            const data = {
                onlineId:id,
                finalApproved:getUserData().userId,
                itemID:itemid
               
                
          };
       
          const addURL="api/onlitms/block";
            
        
      dispatch(itemtatusChange({data,addURL}))
                  .unwrap()
                  .then(()=>{
                   //navigate(`/dashboard/articlesOfc/article/${id}`)
                   window.location.reload();
                    
                  })
            
              }
              
    }  

    const  goToNewsNewsImageView=() => {
        //console.log(page)
        //dispatch(getPaginateArticles({page}))
        
        navigate(`/dashboard/items/imageupload/${id}`)
        
        
    }  
   

    return(
        <>
            { iteminfo && iteminfo.current?
                <div className='article_container'>
                    

                    
                    {iteminfo.current.imageList.length>0 ?
                    <div
                        style={{
                            background:`url(${iteminfo.current.imageList[0].imageUrl})`
                            
                        }}
                        className="image"
                    >
                        <div>
                        <Button
                                             className='mt-3'
                                            variant='contained'
                                            color='error'
                                            onClick={()=>goToNewsNewsImageView(iteminfo.current.onlineId)}
                                            >
                                               Image View
                                               
                                                
                                                </Button>
                            </div>

                                     
                    </div>
                    :null
}                     
                 
                    <h1>{iteminfo.current.brandName}</h1>
                    <Divider className='mt-3 mb-3'/>
                    <h3>{iteminfo.current.finalStatus}</h3>
                    
                    <div>
                    <Divider className='mt-3 mb-3'/>
                    {(iteminfo.current.languageType==1)?
                    
                    <div>
                    <h5>LANGUAGE : ENGLISH</h5>
                   </div>
                   :<div>
                   <h5>LANGUAGE : KANNADA</h5>
                   </div>}
                   <Divider className='mt-3 mb-3'/>
                
                    </div>
                    <h5> SUB TITLE</h5>
                    <h5>{iteminfo.current.itemID}</h5>
                    <Divider className='mt-3 mb-3'/>

                   
                    


                    <>
                   
            <ItemStatusChange
                    iteminfo={iteminfo}
                    type="Item"
                    goToNewsAproval={(id)=> goToNewsAproval(iteminfo.current.onlineId,iteminfo.current.itemID,"item")}
                    goToNewsPublish={(id)=> goToNewsPublish(iteminfo.current.onlineId,iteminfo.current.itemID,"item")}
                    goToNewsBlock={(id)=> goToNewsBlock(iteminfo.current.onlineId,iteminfo.current.itemID,"item")}
                    status={iteminfo.current.finalStatus}
                    

                />
                
            </>
            

          
            <div className='contentcard'>    
            <h2>Item  Dsicription</h2>
                    
            <div>
                  
                    

                  <div className='contentcard' dangerouslySetInnerHTML={
                      {__html: htmlDecode(iteminfo.current.discription)}
                  }>
                     </div>
                  </div>
            </div> 

                  <ItemcostInfo current={iteminfo.current}/>

                  <DateDisplay 
                   time={iteminfo.current.validFrom}
                   state="Valid From "
                  />


                  <DateDisplay 
                   time={iteminfo.current.validTo}
                   state="Valid Till"
                  />

                  
                </div>
            :
                <Loader/>
            }
        </>
    )
    
}

export default ItemInfoOfcView
